import { useEffect, useRef, useState } from 'react';

import { useWindowSize } from '@/hooks';

type ReturnType = {
  areInline: boolean;
  parentRef: React.RefObject<HTMLDivElement>;
};

export const useAreChildrenInline = (): ReturnType => {
  const windowSize = useWindowSize();
  const parentRef = useRef<HTMLDivElement>(null);
  const [areInline, setAreInline] = useState<boolean>(true);
  const [tresholdWindowWidth, setTresholdWindowWidth] = useState<number | undefined>();

  useEffect(() => {
    const firstChildElement = parentRef?.current?.firstElementChild as HTMLElement;
    const lastChildElement = parentRef?.current?.lastElementChild as HTMLElement;

    if (lastChildElement?.offsetTop > firstChildElement?.offsetTop) {
      setAreInline(false);
      setTresholdWindowWidth(windowSize?.width);
    }

    if (tresholdWindowWidth && windowSize?.width && tresholdWindowWidth < windowSize?.width) {
      setAreInline(true);
    }
  }, [tresholdWindowWidth, setTresholdWindowWidth, windowSize?.width]);

  return {
    areInline,
    parentRef,
  };
};
